import { Params } from "react-router-dom";
import {
  NewCtoPermissions,
  OthersPermissions,
  Permission,
  UserPermissionGroup,
} from "../../types/permissionTypes";
import { VesselsResponse } from "../../types/vesselsTypes";
import { RoutesProps } from "../../routes";

export const getVesselsWithPermission = (
  userPermission: UserPermissionGroup[],
): string[] => {
  const vesselsList = Array.from(
    new Set(userPermission?.flatMap((permission) => permission.vessels)),
  );

  return vesselsList;
};

export const hasPermissionByVessel = (
  vesselCode: string,
  userPermission?: UserPermissionGroup[],
  permissionTo?: Permission | NewCtoPermissions,
): boolean => {
  return !!userPermission?.find(
    (group) =>
      group.vessels.includes(vesselCode) &&
      group.permissions.some(
        (permission) => permission.id === permissionTo && permission.enable,
      ),
  );
};

export const hasPermission = (
  userPermission?: UserPermissionGroup[],
  permissionTo?: Permission,
): boolean => {
  return !!userPermission?.find((group) =>
    group.permissions.some(
      (permission) => permission.id === permissionTo && permission.enable,
    ),
  );
};

export const hasPermissionToVessel = (
  userPermission: UserPermissionGroup[] | undefined,
  vesselCode: string | undefined,
): boolean => {
  if (userPermission && vesselCode) {
    return !!userPermission.find((group) =>
      group.vessels.includes(vesselCode.toUpperCase()),
    );
  }

  return false;
};

export const hasPermissionToCountry = (
  country: string,
  vesselsWithPermission: string[] = [],
  vessels: VesselsResponse[] = [],
) => {
  const vesselsByCountry = vessels?.filter(
    (vessel) => vessel.country_code.toUpperCase() === country,
  );
  const hasVessel = !!vesselsByCountry.find((vessel) =>
    vesselsWithPermission.includes(vessel.vessel_code),
  );
  return hasVessel;
};

export const hasPermissionToVesselRoutes = (
  userPermission: UserPermissionGroup[] | undefined,
  params: RoutesProps | Readonly<Params<string>> | undefined,
): boolean => {
  return hasPermissionToVessel(userPermission, params?.vesselId);
};

export const hasPermissionToSupportRequestsRoutes = (
  userPermission: UserPermissionGroup[] | undefined,
): boolean => {
  return hasPermission(userPermission, OthersPermissions.MANAGE_REQUEST);
};
